/**
 * Client-side conversions tracked in the Khan Kids product.
 */
import {
    markMinorConversions,
    type MinorConversionId,
} from "@khan/analytics-learning-time";

function markConversion(
    conversionId: MinorConversionId,
    from?: string | null,
    conversionExtra?: any,
) {
    return markMinorConversions([
        {
            id: conversionId,
            extra: {
                ...conversionExtra,
                // TODO(jangmi, MP-2244): Use withLocation to access SSR safe location.
                // eslint-disable-next-line no-restricted-syntax
                from: from || window.location.pathname,
            },
        },
    ]);
}

export function markLandingPage(
    from?: string | null,
    conversionExtra?: any,
): Promise<Response | null | undefined> {
    return markConversion("khankids_landing_page", from, conversionExtra);
}

export function markAppDownload(
    storeName: string,
    from?: string | null,
    conversionExtra?: any,
): Promise<Response | null | undefined> {
    return markConversion("khankids_app_download", from, {
        ...conversionExtra,
        storeName,
    });
}
